// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_RESERVE_DATE_FOOD_MEALS_REQUESTS_SUCCESS = 'GET_RESERVE_DATE_FOOD_MEALS_REQUESTS_SUCCESS';
const GET_RESERVE_DATE_FOOD_MEAL_REQUESTS_SUCCESS = 'GET_RESERVE_DATE_FOOD_MEAL_REQUESTS_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestReserveDateFoodMealsSuccess(payload) {
  return {
    type: GET_RESERVE_DATE_FOOD_MEALS_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestReserveDateFoodMealSuccess(payload) {
  return {
    type: GET_RESERVE_DATE_FOOD_MEAL_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestReserveDateFoodMeals(params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/feeding/reserve`, {params})
      .then((r) => {
        dispatch(_getRequestReserveDateFoodMealsSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}/**
 * @param {number} reserveDateFoodMealsId
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestReserveDateFoodMeal(reserveDateFoodMealsId, params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/feeding/reserve/${reserveDateFoodMealsId}`, {params})
      .then((r) => {
        dispatch(_getRequestReserveDateFoodMealSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestReserveDateFoodMeals() {
  return _getRequestReserveDateFoodMealsSuccess({data: {daily_reserveDateFoodMeals: []}, meta: {}});
}
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestReserveDateFoodMeal() {
  return _getRequestReserveDateFoodMealSuccess({data: {daily_reserveDateFoodMeal: {}}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
  reserveDateFoodMeals: [],
  reserveDateFoodMeal: {},
}, action) {
  switch (action.type) {
    case GET_RESERVE_DATE_FOOD_MEALS_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        reserveDateFoodMeals: action.payload.reserves,
      });
    case GET_RESERVE_DATE_FOOD_MEAL_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        reserveDateFoodMeal: action.payload.reserve,
      });
    default:
      return state;
  }
}
